import { AppDispatch, RootState, store } from '../index';
import { FetchState } from '../fetchState';
import { baseSlice, BaseType, getItem } from '../baseHelper';
import { ReferenceDto } from '@api/models/employees/ReferenceDto';
import { establishmentService } from '@api/services/services';

type State = BaseType<ReferenceDto[]>;

const initialState: State = {
  state: FetchState.None,
  data: [],
};

export const establishmentLatestSlice = baseSlice({
  name: 'establishmentLatest',
  initialState,
  disableReset: true,
});

export const selectEstablishmentLatestState = (state: RootState) => state.establishmentLatest.state;
export const selectEstablishmentLatest = (state: RootState) => state.establishmentLatest.data;
export const establishmentLatestActions = establishmentLatestSlice.actions;

export const getEstablishmentLatest = () => (dispatch: AppDispatch) => {
  const establishmentLatestState = selectEstablishmentLatestState(store.getState());
  if (establishmentLatestState !== FetchState.None) {
    return;
  }

  const handleGetData = () => {
    return establishmentService.getLatestEstablishmentsUsedBy();
  };

  getItem({
    dispatch,
    actions: establishmentLatestActions,
    getData: handleGetData,
  });
};
